import { defineMessages } from "react-intl"

export const selectCatalogExteriorColorMessages = defineMessages({
	code: {
		defaultMessage: "Code",
		id: "colors.exteriorColor.selectCatalogColorModal.catalog.code",
	},
	colorType: {
		defaultMessage: "Color type",
		id: "colors.exteriorColor.selectCatalogColorModal.catalog.colorType",
	},
	customColor: {
		defaultMessage: "Choose Custom Exterior Color",
		id: "colors.exteriorColor.selectCatalogColorModal.catalog.customColor",
	},
	name: {
		defaultMessage: "Name",
		id: "colors.exteriorColor.selectCatalogColorModal.catalog.name",
	},
	tag: {
		defaultMessage: "Color group",
		id: "colors.exteriorColor.selectCatalogColorModal.catalog.tag",
	},
})
